const template = require('./createContent.html');
require('./createContent.scss');
var logger = require('../../common/logging.config');

class CreateContentController {

	constructor($scope, $state, $filter, contentService, userProfileService, shellUtil) {
		this.state = $state;
		this.buttonDisabled = false;
		this.query = "";
		this.content_types = "";
		this.filtered_content_types = "";
		this.search_icon = require('../../common/icons/search_16.svg');
		this.status = {
			isopen: false
		  };

		$scope.typeaheadToggleOn = shellUtil.isToggleOn('typeahead-createContent');

		contentService.getCurrentContentTypes().then(
			(data) => {
				if ($scope.typeaheadToggleOn){
					if (!data || !data.items){
						logger.error('Error retrieving current content type data from server');
						return;
					}
					
					this.content_types = data.items.filter( (item) => {
						if (item && item.kind){
							return item.kind.includes('standalone');
						}
						else{
							return false;
						}
					});
					this.filtered_content_types = this.content_types;
					logger.info("compose content: number of content types = " + this.content_types.length);
					if (this.content_types.length === 0) {
						this.displayNoContentTypeMessage(userProfileService);
					}
				}
				else{
					$scope.content_types = $filter('createContentFilter')(data.items);
					logger.info("compose content: number of content types = " + $scope.content_types.length);
					if ($scope.content_types.length === 0) {
						this.displayNoContentTypeMessage(userProfileService);
					}
				}
			},
			(error) => {
				logger.error('Error retrieving current content type data from server: ' + error);
			}
		);
		
	}

    select(item) {
        this.selectedType = item;
        this.addContent();
    }

	addContent() {
		this.error = '';
		var type = this.selectedType;
		if (typeof type === 'undefined') {
			this.error = "Select a content type";
		}
		else {
	        if (type && type.id) {
				this.clear();
	            this.state.go('authoring.content.new', { typeId: type.id, typeName: type.name});
	        }
		}
	}
	
	displayNoContentTypeMessage(userProfileService) {
		this.buttonDisabled = true;
		// lookup the role of the current user
		userProfileService.getCurrentUserData().then(
			(data) => {
				const currentUserRole = data.roles[0];
				logger.info("createContent current user role = " + currentUserRole);
				
				switch (currentUserRole) {
				case 'administrator':
				case 'admin':
				case 'manager':
					this.noContentTypeMsg = "NoContentTypesManager";
					this.noContentTypeMsgManager = true;
					break;
				case 'editor':
					this.noContentTypeMsg = "NoContentTypesEditor";
					this.noContentTypeMsgEditor = true;
					break;
				default:
					logger.info('Unexpected user role in createContent: ' + currentUserRole);
					break;
				}
			},
			(error) => {
				logger.error('Error retrieving current user role data from server: ' + error);
			}
		);
	}
	
	createContentType() {
		logger.info("Routing user to authoring to create a new content type...");
        this.state.go('authoring.types.new');
	}
	
	clear() {
		this.selectedType ='';
		this.query = '';
		this.filtered_content_types = this.content_types;
	}

	search() {
		this.filtered_content_types = this.content_types.filter( (item) =>{
			if (item && item.name){
				return item.name.toLowerCase().includes(this.query);
			}
			else{
				return false;
			}
		});
	}

	/**
	 * Callback method when keyup event is triggered on 'Compose content' field
	 * @param event
	 */
	toggle_keyup(event) {
		var charCode = event.charCode || event.keyCode || event.which;
		switch (charCode) {
			// ESC key. Dismisses the popup, clears the textbox
			case 27:
				// When there is a query, clear the query and force dropdown to open
				this.status.isopen = true;
				break;
			default:
				break;
		}
		return true;
	}

	/**
	 * Callback method when keyup event is triggered on input field
	 * @param event
	 */
	input_keyup(event) {
		var charCode = event.charCode || event.keyCode || event.which;
		switch (charCode) {
			// down. If the popup is available, moves focus into the popup
			case 40:
				if (document.activeElement.parentElement.nextElementSibling){
					const firstResultElement = document.activeElement.parentElement.nextElementSibling.querySelector("a");
					if (firstResultElement) firstResultElement.focus();
				}
				break;
			default:
				this.search();
				break;
		}	
		return true;
	}

	/**
	 * Callback method when keyup event is triggered on menu items
	 * @param event
	 */
	item_keyup(event) {
		event = event || window.event;
		event.preventDefault();
		const searchBoxDiv = document.getElementById('typeahead_search_input');

		var charCode = event.charCode || event.keyCode || event.which;
		switch (charCode) {
			// ESC key. Closes the popup and returns focus to the textbox
			case 27:
				this.clear();
				if (searchBoxDiv) searchBoxDiv.focus();
				break;
			// Left Arrow
			case 37:
				if (searchBoxDiv){
					searchBoxDiv.focus();
					const left_pos = searchBoxDiv.selectionStart > 0 ? searchBoxDiv.selectionStart -1 : 0;
					// Move cursor to left by 1 byte
					searchBoxDiv.setSelectionRange(left_pos, left_pos);
				}
				break;
			// Right Arrow
			case 39:
				if (searchBoxDiv){
					searchBoxDiv.focus();
					const right_pos = searchBoxDiv.selectionStart < this.query.length ? searchBoxDiv.selectionStart +1 : this.query.length;
					// Move cursor to right by 1 byte
					searchBoxDiv.setSelectionRange(right_pos, right_pos);
				}
				break;
			// Navigate up
			case 38:
				if (document.activeElement.parentElement.previousElementSibling){
					const prevElement = document.activeElement.parentElement.previousElementSibling.querySelector("a");
					// Navigate up
					if (prevElement) prevElement.focus();
					// Focus to input if it is on first result
					else searchBoxDiv.focus();
				}
				break;
			// Navigate down
			case 40:
				if (document.activeElement.parentElement.nextElementSibling){
					const nextElement = document.activeElement.parentElement.nextElementSibling.querySelector("a");
					if (nextElement) nextElement.focus();
				}
				break;
			// Tab
			case 9:
				break;
			default:
				if (searchBoxDiv) searchBoxDiv.focus();
				this.search();
				break;
		}
		return true;
	}

	// Triggered when you click on "Compose content" toggle
	toggleDropdown($event) {
		$event.preventDefault();
		$event.stopPropagation();
		this.status.isopen = !this.status.isopen;
		this.clear();
	  };
};

module.exports = {
	templateUrl: template,
	controller: ["$scope", "$state", "$filter", "contentService", "userProfileService","shellUtil", CreateContentController]
};



// WEBPACK FOOTER //
// ./app/components/createContent/createContent.component.js